import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import VehiclePlacementReducer from './reducer';
const VehiclePlacement = combineReducers({
    VehiclePlacement: VehiclePlacementReducer,
    form: formReducer
});


export default VehiclePlacement;
